export const MODERATOR_UIDS = ["AeW0Z19GBtMUZjPBjfI51VlJcWn2"];

export function isAdminUser(user) {
	return Boolean(user && MODERATOR_UIDS.includes(user.uid));
}